import React from "react";
import styled from "styled-components";
const StyledTicket = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  background-color: ${p => p.theme.colorTicketBackground};
  border-radius: ${p => p.theme.borderRadius};
  margin-bottom: 1rem;
  color: ${p => p.theme.colorTicketText};
`;
const StyledSide = styled.div`
  z-index: 2;
  flex-shrink: 1;
  background-color: ${p => p.theme.colorTicketBackground};
  width: 50px;
  right: 0px;
  top: 0px;
  position: relative;
  border-left: 4px dashed ${p => p.theme.colorContentBackground};
  border-radius: 0 0.75rem 0.75rem 0;

  .verticalText {
    font-size: 1rem;
    text-transform: uppercase;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    text-align: center;
  }
`;
const Outer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  max-width: 550px;
  flex-shrink: 2;
  @media (max-width: ${p => p.theme.screenWidthSm}) {
    h1 {
      font-size: 2rem;
    }
    h2 {
      font-size: 1rem;
    }
  }
`;
const WinMe = styled.h1`
  color: ${props => props.theme.colorSuccess};
  margin: 0;
  font-size: 3rem;
`;
const PrizeSubTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
`;
const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-transform: uppercase;
  padding-left: 2rem;
  padding-top: 1rem;
`;
const SmallTitle = styled.h3`
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 0;
`;
const DataWrapper = styled.div`
  padding-left: 2rem;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  max-width: 550px;
`;
const TexColumn = styled.div`
  flex: 0 0 auto;

  display: flex;
  flex-direction: column;
  .ticketId {
    font-size: 2rem;
    margin-top: 0;
    margin-right: 1rem;
  }
  .price {
    font-size: 2rem;
    margin-top: 0;
  }
  @media (max-width: 450px) {
    .ticketId {
      font-size: 2rem;
      margin-top: 0;
    }
    .price {
      font-size: 1rem;
      margin-top: 0;
    }
  }
`;
const UnderText = styled.div`
  text-align: center;
  text-transform: capitalize;
  font-size: 1rem;
  margin-top: 1rem;
  padding-bottom: 1rem;
  color: ${props => props.theme.colorTicketLabel};
  @media (max-width: 450px) {
    font-size: 1rem;
  }
`;
const StyledImage = styled.img`
  height: 80px;
  margin-left: -80px;
  position: absolute;
  left: 260px;
  @media (max-width: 450px) {
    left: 180px;
    height: 70px;
    h2 {
      font-size: 1rem;
    }
  }
`;
const Top = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;
const SemiCircle = styled.div`
  height: 40px;
  width: 20px;
  border-radius: 150px 0 0 150px;
  background-color: ${p => p.theme.colorContentBackground};
  position: absolute;
  z-index: 6;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
`;

const Wrapper = ({
  ticketId,
  data,
  prizeImageUrl
}) => {
  const month = data.date.draw.date_time.month.name.short;
  const day = data.date.draw.date_time.day.name.number;
  const year = data.date.draw.date_time.year;
  return /*#__PURE__*/React.createElement(StyledTicket, null, /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Top, null, /*#__PURE__*/React.createElement(WinMe, null, data.name), /*#__PURE__*/React.createElement(StyledImage, {
    src: prizeImageUrl
  })), /*#__PURE__*/React.createElement(PrizeSubTitle, null, data.prize.item)), /*#__PURE__*/React.createElement(DataWrapper, null, /*#__PURE__*/React.createElement(TexColumn, null, /*#__PURE__*/React.createElement(SmallTitle, null, "Ticket no."), /*#__PURE__*/React.createElement("div", {
    className: "ticketId"
  }, " ", ticketId, " ")), /*#__PURE__*/React.createElement(TexColumn, null, /*#__PURE__*/React.createElement(SmallTitle, null, "payment"), /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, " \xA3", data.ticket_price.pounds, " "))), /*#__PURE__*/React.createElement(UnderText, null, "live draw ", month, " ", day, ", ", year)), /*#__PURE__*/React.createElement(StyledSide, null, /*#__PURE__*/React.createElement(SemiCircle, null)));
};

export default Wrapper;